import styled from "styled-components/native"

export const Wrapper = styled.View`
    flex: 1;
    display: flex;
    flex-direction: row;
`